import React from 'react';
import CitizenAlertMessages from "../../utils/citizen-alert-messages.js";

const fieldError = {
    'citizenInfo.cpf': ['cpf.already.registered', 'missing.cpf'],
    'citizenInfo.cnpj': ['cnpj.already.registered', 'missing.cnpj'],
    'citizenInfo.program': ['invalid.program.id'],
    'citizenInfo.name': ['missing.name'],
    'citizenInfo.sex': ['missing.sex'],
    'citizenInfo.dtBirth': ['missing.dtBirth', 'citizenInfo.dtBirth.invalid'],
    'citizenInfo.identificationNumber': ['identificationNumber.already.exists'],
    'aggressor.protectionType': ['protectionType.invalid', 'missing.protectionType'],
    'protectiveMeasure.lifeRisk': ['lifeRisk.invalid'],
    'protectiveMeasure.educationId': ['protectiveMeasure.educationId.invalid'],
    'protectiveMeasure.raceEthnicityId': ['protectiveMeasure.raceEthnicityId.invalid'],
    'protectiveMeasure.religionId': ['protectiveMeasure.religionId.invalid'],
    'aggressor.name': ['aggressor.missing.name'],
    'aggressor.educationId': ['aggressor.educationId.invalid'],
    'aggressor.raceEthnicityId': ['aggressor.raceEthnicityId.invalid'],
    'aggressor.religionId': ['aggressor.religionId.invalid'],
    'aggressor.familyConnectionId': ['aggressor.familyConnectionId.invalid'],
    'aggressor.dtExpiration': ['aggressor.dtExpiration.invalid'],
    'protectedPlaces.addressType': ['protectedPlaces.addressType.invalid', 'protectedPlaces.missing.addressType"'],
    'protectedPlaces.address': ['protectedPlaces.missing.address'],
    'protectedPlaces.number': ['protectedPlaces.missing.number'],
    'protectedPlaces.neighborhood': ['protectedPlaces.missing.neighborhood'],
    'protectedPlaces.latitude': ['protectedPlaces.latitude.invalid', 'protectedPlaces.missing.latitude'],
    'protectedPlaces.longitude': ['protectedPlaces.longitude.invalid', 'protectedPlaces.missing.longitude'],
}

const addressError = ["citizenInfo", "aggressor"];
addressError.forEach(target => {
    fieldError[target + ".address_addressType"] = [target + ".addressType.invalid", target + ".missing.addressType"];
    fieldError[target + ".address_address"] = [target + ".missing.address"];
    fieldError[target + ".address_number"] = [target + ".missing.number"];
    fieldError[target + ".address_neighborhood"] = [target + ".missing.neighborhood"];
    fieldError[target + ".address_latitude"] = [target + ".latitude.invalid", target + ".missing.latitude"];
    fieldError[target + ".address_longitude"] = [target + ".longitude.invalid", target + ".missing.longitude"];
    fieldError[target + ".address_longitude"] = [target + ".longitude.invalid", target + ".missing.longitude"];
    fieldError[target + ".address_longitude"] = [target + ".longitude.invalid", target + ".missing.longitude"];
    fieldError[target + ".address_city"] = [target + ".missing.city"];
    fieldError[target + ".address_district"] = [target + ".missing.district"];
});

const CellRenderer = ({data, colDef, value, valueFormatted}) => {
    let errorMessage = ""
    const field = colDef.field.replace("citizen.", "");
    const find = fieldError[field]?.find(m => data.messages?.includes(m));

    if (find) {
        errorMessage = CitizenAlertMessages[find] ?? ""
    } else if (field.startsWith("aggressor.") && data.messages?.includes("missing.aggressor")) {
        errorMessage = CitizenAlertMessages["missing.aggressor"] ?? ""
    }

    return (
        <div className={`${errorMessage ? "bg-[#F8D7DAFF] w-full h-full flex items-center absolute left-0" : ""} `} title={errorMessage}>
            {valueFormatted ?? value}
        </div>
    );
};

export default CellRenderer;